import clsx from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import * as React from 'react'
import styled, { css } from 'styled-components'
import { tierDarkForegroundBorderColorStyle } from 'styles/utils/tierStyles'

export const AccommodationPackageOptionTileVisualStyle = css`
  padding: ${rem(16)};
  gap: ${rem(12)} ${rem(32)};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};

  ${mediaQueryUp.tablet} {
    padding: ${rem(20)};
    border-top: none;
    border-color: ${props => props.theme.palette.neutral.surface.lightForeground};
  }
`

export const AccommodationPackageOptionTileGrid = styled.div`
  ${AccommodationPackageOptionTileVisualStyle}

  display: grid;
  grid-template:
    "header" auto
    "details" 1fr
    "pricing" auto
    "cta" auto / 1fr;

  ${mediaQueryUp.tablet} {
    grid-template:
      "header header" auto
      "details pricing" auto
      "details cta" 1fr / 1fr ${rem(285)};
  }

  ${mediaQueryUp.desktop} {
    grid-template:
      "header header header" auto
      "details pricing cta" auto / 1fr ${rem(285)} ${rem(185)};
  }
`

const Grid = styled(AccommodationPackageOptionTileGrid)`
  &.loyalty-upgrade-applied {
    border: ${rem(2)} solid;
    ${tierDarkForegroundBorderColorStyle}

    ${mediaQueryUp.tablet} {
      border-top-style: solid;
      border-top-width: ${rem(2)};
    }
  }
`

function AccommodationSameRoomOptionTile({
  loyaltyUpgradeAppliedTier,
  className,
  ...props
}: PropsWithChildren<{
  ref?: React.Ref<HTMLDivElement>
  'data-testid'?: string
  className?: string
  loyaltyUpgradeAppliedTier?: App.LoyaltyTier
}>) {
  return <Grid
    {...props}
    className={clsx(
      className,
      !!loyaltyUpgradeAppliedTier && ['loyalty-upgrade-applied', `tier-${loyaltyUpgradeAppliedTier}`],
    )}
  />
}

export default AccommodationSameRoomOptionTile
